import React from 'react';
import { GameState } from '../api';
import { MythosBreakdown } from './MythosBreakdown';

type ResolutionEntry = NonNullable<NonNullable<GameState['latestMythosSequence']>['entries']>[number];

const Resolution: React.FC<{ entry: ResolutionEntry }> = ({ entry }) => <>
  <p className="game-mythos-resolution-meta">{entry.cardType} · {entry.status}</p>
  <MythosBreakdown
    mythosDetails={{ ...entry.results?.details, name: entry.results?.details?.name || entry.cardName }}
    mythosBreakdown={entry.results?.events ?? []}
  />
</>;

export const LatestMythos: React.FC<{ state: GameState; hideHeading?: boolean }> = ({ state, hideHeading }) => {
  const sequence = state.latestMythosSequence;
  const entries = sequence?.entries ?? [];
  if (!entries.length) return state.mythosDetails?.name ? (
    <section className="game-latest-mythos" id="game-latest-mythos" tabIndex={-1} aria-label="Latest Mythos">
      {!hideHeading && <h3>Latest Mythos</h3>}
      <MythosBreakdown mythosDetails={state.mythosDetails} mythosBreakdown={state.mythosBreakdown} />
    </section>
  ) : null;
  return <section className="game-latest-mythos" id="game-latest-mythos" tabIndex={-1} aria-label="Latest Mythos">
    {hideHeading ? <p>{sequence?.roundLabel}</p> : <h3>Latest Mythos · {sequence?.roundLabel}</h3>}
    {entries.length === 1
      ? <div className="game-mythos-resolution"><Resolution entry={entries[0]} /></div>
      : <ol>{entries.map(entry => <li className="game-mythos-resolution" key={entry.occurrenceId}><Resolution entry={entry} /></li>)}</ol>}
  </section>;
};
